<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import { useAlarmsStore} from "@/stores/alarmsStore";

const tabGroup = ref('call');
const alarmsStore = useAlarmsStore();
const localPopupConfig = ref({});

const headers = [
  {title: 'Train Num', key: 'trainNumber', headerProps: {style: 'font-weight: bold'}},
  {title: 'Time', key: 'timestamp', sortable: true, headerProps: {style: 'font-weight: bold'}, value: item => item.timestamp === null ? "-" : new Date(item.timestamp).toLocaleDateString() + " " + new Date(item.timestamp).toLocaleTimeString()},
  {title: 'Type', key: 'type', headerProps: {style: 'font-weight: bold'}},
  {title: 'Acknowledged By', key: 'ackBy', headerProps: {style: 'font-weight: bold'}, value: item => item.timestamp === null ? "-" : item.ackBy},
  {title: 'Acknowledge Time', key: 'ackTime', headerProps: {style: 'font-weight: bold'}, value: item => item.ackTime === null ? "-" : new Date(item.ackTime).toLocaleDateString() + " " + new Date(item.ackTime).toLocaleTimeString()}
]

onMounted(() => {
  alarmsStore.fetchHistory();
  alarmsStore.alarmHistoryActive = true;
  alarmsStore.lostAlarm = false;
  localPopupConfig.value = { ...alarmsStore.popupConfig };
});

onUnmounted(() => {
  alarmsStore.alarmHistoryActive = false;
})

function savePopupConfig(isActive) {
  alarmsStore.popupConfig = { ...localPopupConfig.value };
  isActive.value = false;
}

function closePopupConfig(isActive) {
  localPopupConfig.value = { ...alarmsStore.popupConfig };
  isActive.value = false;
}

function resetPopupConfig(isActive) {
  alarmsStore.resetPopupConfig();
  localPopupConfig.value = { ...alarmsStore.popupConfig };
  isActive.value = false;
}

</script>

<template>
  <v-col class="d-flex flex-column h-100 pa-0">
    <v-card class="h-100" style="height: 100px;">
      <v-tabs
          v-model="tabGroup"
          bg-color="grey"
          height="30px"
      >
        <v-tab value="outgoing">Historic Alarms</v-tab>
      </v-tabs>
      <v-card-text class="pa-0 h-100">
        <v-tabs-window v-model="tabGroup" style="height: 100%;">
          <v-tabs-window-item style="height: 100%;" value="outgoing">
            <v-data-table
                :headers="headers"
                :items="alarmsStore.getHistory"
                :items-per-page="-1"
                density="compact"
                fixed-header
                hide-default-footer
                item-value="id"
                style="height: 100%;"
            >
            </v-data-table>
          </v-tabs-window-item>

        </v-tabs-window>
      </v-card-text>
    </v-card>
    <div id="controls" class="border-t w-100 d-flex justify-start align-center pt-1 pb-1">
      <v-dialog width="auto" scrollable persistent>
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn
              class="ml-3"
              prepend-icon="mdi-cog"
              text="Popup Options"
              v-bind="activatorProps"
          ></v-btn>
        </template>

        <template v-slot:default="{ isActive }">
          <v-card prepend-icon="mdi-cog" title="Popup Options" style="width: 300px">
            <div style="color: #666; text-align: center">
              Choose alarms to show as popoup.
            </div>
            <v-divider class="mt-3"></v-divider>

            <v-card-text class="px-4" style="height: 300px">
              <v-checkbox
                  v-for="(enabled, type) in localPopupConfig"
                  :key="type"
                  :label="type"
                  v-model="localPopupConfig[type]"
              ></v-checkbox>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn text="Close" @click="closePopupConfig(isActive)"></v-btn>
              <v-spacer></v-spacer>
              <v-btn text="Reset" @click="resetPopupConfig(isActive)"></v-btn>
              <v-spacer></v-spacer>
              <v-btn
                  color="surface-variant"
                  text="Save"
                  variant="flat"
                  @click="savePopupConfig(isActive)"
              ></v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </div>
  </v-col>

</template>

<style scoped>

.v-card {
  border-radius: 0%;
}

:deep(.v-input__details) {
  display: none;
}

#controls {
  height: 60px;
  background-color: darkgray;
}


</style>